import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { PhotoGallery, Redirect } from "components";
import { isEmpty } from "utils/helperFunction";
import { getGalleries } from "services/photoGallery.api";
function PhotoGalleryDetails() {
    var ref = useRouter(), locale = ref.locale, query = ref.query;
    var ref1 = useQuery([
        "gallery-".concat(query.slug)
    ], function() {
        return getGalleries(locale, {
            filters: {
                slug: {
                    $eq: query.slug
                }
            }
        });
    }), images = ref1.data, isLoading = ref1.isLoading, isError = ref1.isError;
    if (isEmpty(images.data)) {
        return /*#__PURE__*/ _jsx(Redirect, {});
    }
    return /*#__PURE__*/ _jsx(PhotoGallery, _object_spread_props(_object_spread({}, images.data[0].attributes), {
        isLoading: isLoading,
        isError: isError
    }));
}
export var __N_SSG = true;
export default _withSuperJSONPage(PhotoGalleryDetails);
